import React from 'react';
import { Avatar, Box, CardHeader, Typography, useTheme } from '@mui/material';
import ModalDialog from '../../common/components/ModalDialog';
import { PendingInvitationMember } from '../types/members-types';
import { Nullable } from 'common-types';
import ButtonGroup from '../../common/components/ButtonGroup';

interface IRevokeInvitationModalProps {
  open: boolean;
  pendingInvitationMember: Nullable<PendingInvitationMember>;
  onClose: () => void;
  onRevoke: () => void;
  isLoading: boolean;
}

const RevokeInvitationModal: React.FC<
  React.PropsWithChildren<IRevokeInvitationModalProps>
> = props => {
  const theme = useTheme();

  const { open, onClose, pendingInvitationMember, onRevoke, isLoading } = props;

  if (!pendingInvitationMember) {
    return null;
  }

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label='Revoke Invitation'
      open={open}
      onClose={onClose}
      modalHeader='Revoke Invitation'>
      <Box sx={{ flexGrow: 1, mb: 2, gap: 5 }}>
        <Typography>
          {`Are you sure you want to revoke the invitation for`}
        </Typography>
        <CardHeader
          avatar={
            <Avatar
              alt={pendingInvitationMember.inviteeEmail}
              sx={{ width: 24, height: 24 }}
            />
          }
          title={pendingInvitationMember.inviteeEmail}
        />
      </Box>
      <ButtonGroup
        onCancel={onClose}
        onClick={onRevoke}
        isLoading={isLoading}
        buttonCancelLabel={'Cancel'}
        buttonCancelTooltip={'Cancel this operation'}
        buttonActionLabel={'Revoke'}
        buttonActionTooltip={'Revoke members invitation'}
        buttonActionColor={'error'}
        isActionDisabled={false}
      />
    </ModalDialog>
  );
};

export default RevokeInvitationModal;
